import { useEffect, useRef, useState } from "react";
import {
  LeaseAgreementService,
  LeaseAgreementStatusTypesEnum,
  LeaseApplicationService,
  TemplateService,
} from "@propertelligent/client-api";
import apiHelper from "../../../utils/apiHelper";
import SignatureCard from "../../TenantOnboard/RenderSteps/SignatureCard";
import { useError } from "../../../utils/context/ErrorContext";
import { utcDateFormat } from "../../../utils/helper";
import DateHelper from "../../../utils/DateHelper";
import { GetImages } from "../../../utils/GetImages";
import { PubSub, TopicsEnum } from "../../../utils/pubsub";
import OrganizationNameHeader from "../../common/OrganizationNameHeader/OrganizationNameHeader";

const ShowLeaseAgreement = ({
  currentLeaseAgreementId = null,
  leaseApplicationId,
  postLeaseAgreement,
  setPostLeaseAgreement,
  onCancel,
  onClick,
  buttonName,
  selectedTemplateid,
  userData,
  role = "landlord",
  selectedTemplates,
  showHeader = true,
  showAgreementModel = false,
  isPreview = false,
  leaseApplicationData = undefined,
  setIsPrint = undefined,
  isPrint = false,
  isLoading = false,
  readCurrentAgreemnet = false,
  subHeaderName = "",
  orgDetails = undefined,
}) => {
  const { setErrors, setErrorMessages } = useError();
  const [selectedTemplate, setSelectedTemplate] =
    useState<any>(selectedTemplates);
  const contentRef = useRef();
  const [section1, setsection] = useState<any>();
  const [tempId, setTempId] = useState();

  const getLeaseAgreement = () => {
    if (readCurrentAgreemnet) {
      apiHelper(
        LeaseAgreementService.getApiLeaseAgreement1,
        { showNotification: false },
        Number(currentLeaseAgreementId)
      ).then((res) => {
          if (res?.data?.success) {
            const temp = res?.data?.success?.templateId;
            setTempId(temp);
            setsection(res?.data?.success);
            setPostLeaseAgreement((prevState) => ({
              ...prevState,
              leaseAgreementStatus: res?.data?.success?.leaseAgreementStatus,
              leaseAgreementId: Number(res?.data?.success.id),
              leaseAgreementStatusTypeId:
                res?.data?.success?.leaseAgreementStatusTypeId,
              templateId: selectedTemplateid,
              paymentDueAccountIds: res?.data?.success?.paymentDueAccountIds,
               dataAttributes: {
                ...res?.data?.success?.dataAttributes,       // LesseeName, UnitAddress
                StartDate:res?.data?.success?.formatted?.StartDateDateOnly,
                EndDate: res?.data?.success?.formatted?.EndDateDateOnly,
                Rent: res?.data?.success?.rent?.toString(),
                SecurityDeposit: res?.data?.success?.securityDeposit?.toString(),
                LeaseType: res?.data?.success?.leaseTypeId?.toString(),
              },
              tenantSignature: res?.data?.success?.tenantSignature,
              landlordSignature: res?.data?.success?.landlordSignature,
            }));
            getTempleteData(temp);
          }
        })
        .catch((err) => {
          console.error("Error fetching template data:", err);
        });

      return;
    }

    else if (leaseApplicationId) {
      apiHelper(
        LeaseAgreementService.getApiLeaseAgreementFromLeaseApplication,
        { showNotification: false },
        Number(leaseApplicationId)
      )
        .then((res) => {
          if (res?.data?.success) {
            const temp = res?.data?.success?.templateId;
            setTempId(temp);
            setsection(res?.data?.success);
            setPostLeaseAgreement((prevState) => ({
              ...prevState,
              leaseAgreementId: Number(res?.data?.success.id),
              leaseAgreementStatusTypeId:
                res?.data?.success?.leaseAgreementStatusTypeId,
              templateId: selectedTemplateid,
              paymentDueAccountIds: res?.data?.success?.paymentDueAccountIds,
               dataAttributes: {
                ...res?.data?.success?.dataAttributes,       // LesseeName, UnitAddress
                StartDate: res?.data?.success?.formatted?.StartDateDateOnly,
                EndDate: res?.data?.success?.formatted?.EndDateDateOnly,
                Rent: res?.data?.success?.rent?.toString(),
                SecurityDeposit: res?.data?.success?.securityDeposit?.toString(),
                LeaseType: res?.data?.success?.leaseTypeId?.toString(),
              },
              tenantSignature: res?.data?.success?.tenantSignature,
              landlordSignature: res?.data?.success?.landlordSignature,
            }));
            getTempleteData(temp);
          }
        })
        .catch((err) => {
          console.error("Error fetching template data:", err);
        });
    } else if (currentLeaseAgreementId) {
      apiHelper(
        LeaseAgreementService.getApiLeaseAgreementFromLeaseAgreement,
        { showNotification: false },
        Number(currentLeaseAgreementId)
      )
        .then((res) => {
          if (res?.data?.success) {
            const temp = res?.data?.success?.templateId;

            setTempId(temp);
            setsection(res?.data?.success);
            setPostLeaseAgreement((prevState) => ({
              ...prevState,
              leaseAgreementStatus: res?.data?.success?.leaseAgreementStatus,
              leaseAgreementId: Number(res?.data?.success.id),
              leaseAgreementStatusTypeId:
                res?.data?.success?.leaseAgreementStatusTypeId,
              templateId: selectedTemplateid,
              paymentDueAccountIds: res?.data?.success?.paymentDueAccountIds,
              dataAttributes: {
                ...res?.data?.success?.dataAttributes,       // LesseeName, UnitAddress
                StartDate: res?.data?.success?.formatted?.StartDateDateOnly,
                EndDate: res?.data?.success?.formatted?.EndDateDateOnly,
                Rent: res?.data?.success?.rent?.toString(),
                SecurityDeposit: res?.data?.success?.securityDeposit?.toString(),
                LeaseType: res?.data?.success?.leaseTypeId?.toString(),
              },
              tenantSignature: res?.data?.success?.tenantSignature,
              landlordSignature: res?.data?.success?.landlordSignature,
            }));
            getTempleteData(temp);
          }
        })
        .catch((err) => {
          console.error("Error fetching template data:", err);
        });
    }
  };
  const getTempleteData = (id) => {
    const finalId = id || selectedTemplateid || tempId;
    if (finalId) {
      apiHelper(
        TemplateService.getApiTemplate,
        { showNotification: false },
        Number(finalId)
      )
        .then((res) => {
          if (res?.data?.success) {
            const templateData = res?.data?.success;
            setSelectedTemplate(templateData);
          }
        })
        .catch((err) => {
          console.error("Error fetching template data:", err);
        });
    }
  };
  const tenantEdit =
    role == "tenant" &&
    section1?.leaseAgreementStatusTypeId ==
    LeaseAgreementStatusTypesEnum.PendingTenantSignature;
  const landlordEdit =
    role == "landlord" &&
    (section1?.leaseAgreementStatusTypeId ==
      LeaseAgreementStatusTypesEnum.PendingLandlordSignature ||
      section1?.leaseAgreementStatusTypeId ==
      LeaseAgreementStatusTypesEnum.Signed);

  useEffect(() => {
    if (!selectedTemplates) {
      getLeaseAgreement();
    }
  }, [Number(leaseApplicationId), selectedTemplateid]);

  useEffect(() => {
    if (tempId || selectedTemplateid) {
      getTempleteData(tempId || selectedTemplateid);
    }
  }, [tempId, selectedTemplateid]);

  const formatDate = (dateString: string): string => {
    if (!dateString) return dateString;

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return `${(date.getMonth() + 1).toString().padStart(2, "0")}-${date
      .getDate()
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  const normalizeDataAttributes = (source: any) => {
    const flat: any = {};
    if (!source) return flat;
  
    // 1) Saare primitive fields (string/number) uthao
    Object.entries(source).forEach(([key, value]) => {
      if (value === null || value === undefined) return;
      if (typeof value === "string" || typeof value === "number") {
        flat[key] = value;
      }
    });
  
    // 2) Agar leaseTypeId hai to LeaseType bhi banao (1/2 -> Month-to-Month / Fixed-Term)
    if (source.leaseTypeId !== undefined && flat.LeaseType === undefined) {
      flat.LeaseType = String(source.leaseTypeId);
    }
  
    // 3) Agar startDate / endDate raw fields hain to friendly aliases banao
    if (source.startDate && !flat.StartDate) {
      flat.StartDate = source.startDate;
    }
    if (source.endDate && !flat.EndDate) {
      flat.EndDate = source.endDate;
    }
  
    // 4) Agar nested tenant/unit objects hain to unke useful fields uthao
    if (source.tenant && source.tenant.fullName && !flat.LesseeName) {
      flat.LesseeName = source.tenant.fullName;
    }
    if (source.unit && source.unit.streetAddress && !flat.UnitAddress) {
      flat.UnitAddress = source.unit.streetAddress;
    }
  
    return flat;
  };
  const replacePlaceholders = (htmlString: string, dataAttributes: any) => {
    const flatAttrs = normalizeDataAttributes(dataAttributes);
    const regex = /\[([^\]]+)\]/g;
    return htmlString
      ?.replace(/<span class="close-btn">×<\/span>/g, "")
      .replace(regex, (_, key) => {
        const trimmedKey = key.trim();
let value = flatAttrs[trimmedKey];

if (value === undefined) {
  const lower = trimmedKey.toLowerCase();
  const matchKey = Object.keys(flatAttrs).find(
    (k) => k.toLowerCase() === lower
  );
  if (matchKey) value = flatAttrs[matchKey];
}

if (value === undefined) {
  value = `[${key}]`; // fallback
}
        return `${value}`;
      });
  };

  useEffect(() => {
    const unsubscribe = PubSub.subscribe(
      TopicsEnum.RefreshLeaseData.toString(),
      () => {
        getLeaseAgreement();
      }
    );
    return () => unsubscribe();
  }, []);
  return (
    <>
      <div ref={contentRef} className="showLeaseAgreementSettings_main  px-3">
        <div className="agreement-container">
          <div className="flexColumn gap-2">
            <div className="flexColumn gap-3">
              <p className="normal_text lh-lg">
                {" "}
                The word "Landlord" as used in this Lease means all of the
                landlords above listed. In all instances in which the Landlord
                may exercise rights or perform obligations under this Lease, it
                may do so through its authorized agents or representatives.
              </p>
              <p className="normal_text lh-lg">
                The word "Tenant" as used in this Lease means all of the tenants
                above listed.
              </p>
            </div>
            <div className="leaseAgreementTemplateSections">
              {selectedTemplate?.leaseAgreementTemplateSections?.map(
                (section, index) => (
                  <div key={index} style={{ marginBottom: "20px" }}>
                    {section?.sectionName && section?.sectionData && (
                      <p className="main_heading text-uppercase">
                        {section?.sectionName.includes(":")
                          ? section?.sectionName
                          : `${section?.sectionName} :`}
                      </p>
                    )}
                    <div
                      className="aggrementSectionData"
                      dangerouslySetInnerHTML={{
                        __html: replacePlaceholders(section?.sectionData, {
                          ...(section1 || {}),
                          ...(section1?.formatted || {}),
                          ...(section1?.dataAttributes || {}),
                          ...(postLeaseAgreement?.dataAttributes || {}),
                        }),
                      }}
                    />
                  </div>
                )
              )}
            </div>
          </div>
          <div className="flexRow w-100 justify-content-between">
            {section1?.tenantSignature && (
              <div className="">
                <div className="d-flex gap-3  align-items-center">
                  <div className="BackgroundlightBlue CommonRoundBackgroundNoSize iconstyle24">
                    <img
                      className="color-white-icon"
                      alt="aggrement-tenant-sign"
                      src={GetImages.Signed}
                    />
                  </div>
                  <p className="signature">
                    {section1?.tenantSignature?.fullName}
                  </p>
                </div>
                <p className="normal_text black w-100">
                  Date Signed :{" "}
                  {DateHelper.formatISOToMMDDYYYYTime(
                    section1?.tenantSignature?.signedDateTime)
                  }

                </p>
              </div>
            )}
            {section1?.landlordSignature && (
              <div className="">
                <div className="d-flex gap-3  align-items-center">
                  <div className="BackgroundlightBlue CommonRoundBackgroundNoSize iconstyle24">
                    <img
                      className="color-white-icon"
                      alt="aggrement-tenant-sign"
                      src={GetImages.Signed}
                    />
                  </div>
                  <p className="signature">
                    {section1?.landlordSignature?.fullName}
                  </p>
                </div>
                <p className="normal_text black w-100">
                  Date Signed :{" "}
                  {DateHelper.formatISOToMMDDYYYYTime(
                    section1?.landlordSignature?.signedDateTime)
                  }
                </p>
              </div>
            )}
            {(tenantEdit === true || isPreview === true || isPrint === true) && !section1?.tenantSignature ? (
              <SignatureCard
                clause={undefined}
                displayCheckbox={false}
                formData={
                  postLeaseAgreement?.tenantSignature?.fullName == ""
                    ? leaseApplicationData?.Signature
                    : postLeaseAgreement?.tenantSignature
                }

                setFormData={undefined}
                editable={tenantEdit}
                isPreview={isPreview}
                handleChange={(e) => {
                  const { name, value } = e.target;
                  setPostLeaseAgreement((preValue) => ({
                    ...preValue,
                    tenantSignature: {
                      ...preValue.tenantSignature,
                      [name]:
                        name === "signedDateTime"
                          ? utcDateFormat(new Date().toISOString())
                          : value,
                    },
                  }));
                  const errorKey = `${name}`;
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    [errorKey]: false,
                  }));
                  setErrorMessages((prevMessages) => ({
                    ...prevMessages,
                    [errorKey]: "",
                  }));
                }}
                handleClick={onClick}
              />
            ) : (((landlordEdit === true && role === "landlord") || (role === "landlord" && isPrint)) && !section1?.landlordSignature) ? (
              <div className=" w-100 align-items-end">
                <SignatureCard
                  clause={undefined}
                  handleClick={onClick}
                  formData={postLeaseAgreement?.landlordSignature}
                  setFormData={undefined}
                  editable={landlordEdit}
                  landlordEdit={landlordEdit}
                  displayCheckbox={false}
                  buttonName="Sign Agreement"
                  isPreview={
                    postLeaseAgreement?.leaseAgreementStatusTypeId ==
                      LeaseAgreementStatusTypesEnum.Signed
                      ? true
                      : isPreview || isPrint
                  }
                  handleChange={(e) => {
                    const { name, value } = e.target;
                    setPostLeaseAgreement((preValue) => ({
                      ...preValue,
                      landlordSignature: {
                        ...preValue.landlordSignature,
                        [name]:
                          name === "signedDateTime"
                            ? utcDateFormat(value)
                            : value,
                      },
                    }));
                    const errorKey = `${name}`;
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      [errorKey]: false,
                    }));
                    setErrorMessages((prevMessages) => ({
                      ...prevMessages,
                      [errorKey]: "",
                    }));
                  }}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ShowLeaseAgreement;
